exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yearSelector__yearSelector___2jXla {\n  margin-bottom: -5px; }\n  .yearSelector__yearSelector___2jXla div[role='combobox'][aria-haspopup=\"true\"].ant-select-selection {\n    border: none; }\n    .yearSelector__yearSelector___2jXla div[role='combobox'][aria-haspopup=\"true\"].ant-select-selection .ant-input:focus {\n      border: none; }\n  .yearSelector__yearSelector___2jXla .yearSelector__title___3r6yq {\n    margin-bottom: 21px; }\n", ""]);

// exports
exports.locals = {
	"yearSelector": "yearSelector__yearSelector___2jXla",
	"title": "yearSelector__title___3r6yq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/YearSelector/yearSelector.scss
// module id = 2176
// module chunks = 6